<div class="claim-account-holder">
    <serviceos-ng-local-loader [showLoader]="showLocalLoader"></serviceos-ng-local-loader>
    <div class="title-holder">
        <h2 *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{moduleAuthTexts.claim_label ? moduleAuthTexts.claim_label : 'Claim My Account'}}</h2>
        <serviceos-ng-alert class="error-alert" *ngIf="formErrorMessage" [type]="'error'">
            {{ formErrorMessage }}
        </serviceos-ng-alert>
    </div>
    <form
        [formGroup]="resetPasswordForm"
        (ngSubmit)="processForm()"
        #templateResetPForm="ngForm"
        *ngIf="!emailSent; else confirmationMessageBox"
    >
        <div class="obf-form-part">
            <div class="mb-3">
                <p *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{moduleAuthTexts.claim_confirm_ver_message ? moduleAuthTexts.claim_confirm_ver_message : 'Please enter the email address you have provided when you have booked your service over the phone or chat. We will send you an email containing a verification link that enables you to access your bookings.'}}</p>
            </div>
            <div class="input-holder">
                <serviceos-ng-form-field>
                    <serviceos-ng-label *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.email_field_label ? moduleAuthTexts.email_field_label : componentSettings?.fields?.email?.label }}</serviceos-ng-label>
                    <input
                        [serviceosNgInput]="email?.value"
                        [error]="
                        email?.invalid && templateResetPForm.submitted
                        "
                        type="text"
                        id="email"
                        name="email"
                        formControlName="email"
                    />
                    <serviceos-ng-error-message *ngIf="email?.errors?.email && email?.value?.length">
                        <ng-container *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">
                            {{ moduleAuthTexts.email_field_error ? moduleAuthTexts.email_field_error : componentSettings?.fields?.email?.errMsgs?.format }}
                        </ng-container>
                    </serviceos-ng-error-message>
                    <serviceos-ng-error-message *ngIf="!(email?.errors?.email && email?.value?.length)">
                        <ng-container *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">
                            {{ moduleAuthTexts.email_field_error ? moduleAuthTexts.email_field_error : componentSettings?.fields?.email?.errMsgs?.required }}
                        </ng-container>
                    </serviceos-ng-error-message>
                </serviceos-ng-form-field>
            </div>

            <div>
                <serviceos-ng-button
                    [isSubmitButton]="true"
                    [type]="'primary'"
                    [isFullWidth]="true"
                    *ngIf="moduleAuthTexts$ | async as moduleAuthTexts"
                    >
                    {{ moduleAuthTexts.submit_button_label ? moduleAuthTexts.submit_button_label :componentSettings?.fields?.submitButton?.label }}
                </serviceos-ng-button>
            </div>
        </div>
    </form>

    <ng-template #confirmationMessageBox>
        <p *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">
            {{ moduleAuthTexts.claim_confirm_message ? moduleAuthTexts.claim_confirm_message : 'Thank you! We have ve just sent an email with a verification link. Please check your inbox and follow the instructions!' }}
        </p>
    </ng-template>

    <div class="back-to-login">
        <span
            class="link-color cursor"
            (click)="changeScreenHandler('login')"
            *ngIf="moduleAuthTexts$ | async as moduleAuthTexts"
            >
            {{ moduleAuthTexts.back_button_label ? moduleAuthTexts.back_button_label : 'Go back' }}
        </span>
    </div>
</div>
    